export default __webpack_public_path__ + "static/media/standard-car-new.7b4f8430.svg";